// servizi/giorni.ts — v037: «partita del giorno» e giorni di fila. Il telefono ricorda i giorni in cui hai giocato
// (al massimo 60, nel fuso del telefono); la Home mostra «🔥 3 giorni di fila» e invita a non perdere la serie. Il
// premio in stelle della prima partita valida del giorno lo dà il server (crediti «giorno»).
// Qui solo i conti (provati senza il telefono); il salvataggio è in giorniSalvati.ts.

export function giornoLocale(d = new Date()): string {
  const p = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** Aggiunge oggi all'elenco (più recenti prima, al massimo 60). */
export function conGiorno(giorni: readonly string[], d = new Date()): string[] {
  const g = giornoLocale(d);
  return giorni.includes(g) ? [...giorni] : [g, ...giorni].sort().reverse().slice(0, 60);
}

/** Giorni di fila fino a oggi (o fino a ieri, se oggi non hai ancora giocato: la serie non è ancora persa). */
export function serieGiorni(giorni: readonly string[], oggi = new Date()): { giorni: number; oggi: boolean } {
  const set = new Set(giorni);
  const giocatoOggi = set.has(giornoLocale(oggi));
  const d = new Date(oggi);
  if (!giocatoOggi) d.setDate(d.getDate() - 1);
  let n = 0;
  while (set.has(giornoLocale(d))) {
    n++;
    d.setDate(d.getDate() - 1);
  }
  return { giorni: n, oggi: giocatoOggi };
}
